import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export interface TteOfficial {
    id: number;
    period_id: number;
    certificate_type: 'all' | 'konvensi' | 'konferensi';
    conference_id?: number | null;
    certificate_type_ids?: number[] | null;
    niu: string;
    nip?: string | null;
    name: string;
    position: string;
    no_urut?: number;
    page?: string;
    tag_kordinat?: string;
    affiliation?: string;
    created_at?: string;
    updated_at?: string;
}

export const useAdminTteOfficials = (period_id?: string) => {
    return useQuery({
        queryKey: ["admin-tte-officials", period_id],
        queryFn: async () => {
            const params: any = {};
            if (period_id && period_id !== "all") params.period_id = period_id;

            const { data } = await axiosClient.get("/private/tte-officials", { params });
            return data as TteOfficial[];
        },
    });
};

export const useCreateTteOfficial = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: Partial<TteOfficial>) => {
            const { data } = await axiosClient.post("/private/tte-officials", payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-tte-officials"] });
        },
    });
};

export const useUpdateTteOfficial = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: Partial<TteOfficial> }) => {
            const { data } = await axiosClient.put(`/private/tte-officials/${id}`, payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-tte-officials"] });
        },
    });
};

export const useDeleteTteOfficial = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => {
            const { data } = await axiosClient.delete(`/private/tte-officials/${id}`);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-tte-officials"] });
        },
    });
};
